
import React, { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from './ui/button';

interface CalendlyWidgetProps {
  url: string;
}

declare global {
  interface Window {
    Calendly: any;
  }
}

const CalendlyWidget: React.FC<CalendlyWidgetProps> = ({ url }) => {
  const { language } = useLanguage();
  
  const buttonText = {
    fr: "Faites vous rappeler",
    en: "Speak with an advisor",
    de: "Sprechen Sie mit einem Berater"
  };

  useEffect(() => {
    // Dynamically load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleCalendlyClick = () => {
    const calendlyUrl = url || "https://calendly.com/legatia/15min";
    if (window.Calendly) {
      console.log('Opening Calendly widget with URL:', calendlyUrl);
      window.Calendly.initPopupWidget({
        url: calendlyUrl
      });
      return true;
    } else {
      console.error('Calendly not initialized');
      // Fallback: open Calendly in new tab if widget fails
      window.open(calendlyUrl, '_blank');
      return false;
    }
  };

  return (
    <Button 
      className="animate-fade-in bg-legatia-orange hover:bg-legatia-orange/90 text-white"
      style={{ animationDelay: "0.8s" }}
      onClick={handleCalendlyClick}
    >
      {buttonText[language] || buttonText.fr}
    </Button>
  );
};

export default CalendlyWidget;

